import { Divider } from "@blueprintjs/core";
import React from "react";
import BusConfigurationCard from "./BusConfigurationCard";
import BusGeneralInfoSection from "./BusGeneralInfoSection";
import "./BusPage.scss";
import BusResultsSection from "./BusResultsSection";
import BusScopeAssumptionsSection from "./BusScopeAssumptionsSection";
import RelatedProjectsPanel from "./RelatedProjectsPanel";
import RestudyPanel from "./RestudyPanel";

export const BusPage: React.FC = () => {
    return (
        <div className="BusPage-wrapper">
            <div className="BusPage-page">
                <div className="BusPage-body">
                    <BusGeneralInfoSection />
                    <Divider className="BusPage-divider" />
                    <BusScopeAssumptionsSection />
                    <Divider className="BusPage-divider" />
                    <BusResultsSection />
                </div>
                <div className="BusPage-sidebar">
                    <BusConfigurationCard />
                    <RestudyPanel />
                    <RelatedProjectsPanel />
                </div>
            </div>
        </div>
    );
};
